import { IProjectEstimatePhaseStepDetail } from '../../interfaces/iproject-estimate-phase-step-detail';
import { ProjectEstimate } from '../project-estimate';

export class ProjectEstimatePhaseStepDetailBase {
  ProjectEstimatePhaseStepDetailId: number;
  Phase: string | null;
  Step: string | null;
  Duration: number | null;
  Cost: number | null;
  DepthStart: number | null;
  DepthEnd: number | null;
  ProjectEstimateId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectEstimate?: ProjectEstimate;

  constructor(item?: IProjectEstimatePhaseStepDetail) {
    if (item) {

      this.ProjectEstimatePhaseStepDetailId = item.ProjectEstimatePhaseStepDetailId;
      this.Phase = item.Phase;
      this.Step = item.Step;
      this.Duration = item.Duration;
      this.Cost = item.Cost;
      this.DepthStart = item.DepthStart;
      this.DepthEnd = item.DepthEnd;
      this.ProjectEstimateId = item.ProjectEstimateId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectEstimate = new ProjectEstimate(item.ProjectEstimate);
    }
  }
}